import { Component, OnInit} from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material';
import { AlertService, Constants } from 'src/app/shared';
import { UserManagementService } from 'src/app/services/index';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { SiteModel } from 'src/app/models/index';

@Component({
  selector: 'app-sso-login-modal',
  templateUrl: './sso-login-modal.component.html',
  styleUrls: ['./sso-login-modal.component.scss']
})
export class SsoLoginModalComponent implements OnInit {
  formData: FormGroup;
  model: any;
  public ntID: string;
  constructor(private dialogRef: MatDialogRef<SsoLoginModalComponent>, private fb: FormBuilder,
    private userManagementService: UserManagementService, private alertService: AlertService) { }

  ngOnInit() {
    this.formData = this.fb.group({
      userNameCtr: ['', [Validators.required]],
      passwordCtr: ['', [Validators.required]],
      rememberCtr: []
    });
    this.model = {
      userName: '',
      password: '',
      rememberMe: false
    };
  }
  login() {
    const param = {
      'ntUsername': this.model.userName,
      'ntPassword': this.model.password,
      'ntIDToCheck': this.ntID,
      'rememberMe': this.model.rememberMe
    };
    
    this.userManagementService.ValidateNTID(param).subscribe(data => {
      if (data) {
        this.dialogRef.close({ status: true, data: data });
      }
    });
  }
  close(confirm: boolean) {
    this.dialogRef.close({ status: confirm, data: null });
  }
}
